import {fetch} from '@logistics-frontend/core/utils/network'
import {cargoApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery, stubObject} from '@yandex-delivery/utils'

import type {MakeUrlApi} from 'src/shared/types'

export function fetchOrderAvailability(
  clientId: string,
  country?: string,
  makeUrl: MakeUrlApi = cargoApiURL,
): Promise<{}> {
  return fetch({
    url: addQuery(makeUrl('cargo-corp/v1/client/order/availability'), {country}),
    method: 'POST',
    headers: {
      'X-B2B-Client-ID': clientId,
    },
    body: stubObject(),
  })
}
